import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=676db012&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676db012')) {
      api.createRecord('676db012', component.options)
    } else {
      api.reload('676db012', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=676db012&", function () {
      api.rerender('676db012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DeedtC49U5Gc/JS/comp/ImgFallback.vue"
export default component.exports